<template>
  <PrestationsPage
    title_1="Mains"
    title_2="& pieds"
    :sections="sections"
    :images="images">
    <template #prestationFooter>
      <h2 class="section-title">
        Par mesure d’hygiène, chaque client(e) a sa lime et elle sera facturée
        au 1er rendez-vous et quand celà sera necessaire (à partir de 3,50€).
      </h2>
    </template>
  </PrestationsPage>
</template>

<script>
import GlobalMixin from '@/mixins/global.mixin'
import { Component } from 'vue-property-decorator'
import PrestationsPage from '@/components/PrestationsPage'

@Component({
  components: {
    PrestationsPage
  }
})

export default class Page extends GlobalMixin {

  data() {
    return {
      images: undefined,

      sections: [
        {
          title: '',
          subSections: [
            {
              title: '',
              items: [
                {
                  name: 'Manucure flash',
                  alternatives: [
                    {
                      description: '2 zones',
                      duration: '',
                      price: '20€',
                    }
                  ]
                },
                {
                  name: 'Pose de vernis classique',
                  alternatives: [
                    {
                      description: '',
                      duration: '20 min',
                      price: '16€',
                    }
                  ]
                },
                {
                  name: 'Soin des mains',
                  alternatives: [
                    {
                      description: 'Beauté des ongles, Gommage, Masque & Massage',
                      duration: '60 min',
                      price: '39€',
                    },
                    {
                      description: '+ pose de vernis',
                      duration: '',
                      price: '50€',
                    }
                  ]
                },
                {
                  name: 'Soin des pieds',
                  alternatives: [
                    {
                      description: 'SPA, beauté des ongles, Gommage, Masque & Massage',
                      duration: '60 min',
                      price: '45€',
                    }
                  ]
                },
                {
                  name: 'Yumi Feet',
                  alternatives: [
                    {
                      description: 'Soin peeling des pieds + Soind des ongles',
                      duration: '60 min',
                      price: '45€',
                    },
                    {
                      description: 'Duo Soin Yumi Feet + Semi-Permanent',
                      duration: '',
                      price: '59€',
                    },
                    {
                      description: 'Duo Soin Yumi Feet + dépose et pose de Semi-Permanent',
                      duration: '',
                      price: '69€',
                    },
                  ]
                },
                {
                  name: 'Pose de vernis semi-permanent',
                  alternatives: [
                    {
                      description: '',
                      duration: '45 min',
                      price: '33€',
                    }
                  ]
                },
                {
                  name: 'Dépose & pose de vernis semi-permanent',
                  alternatives: [
                    {
                      description: '',
                      duration: '60 min',
                      price: '43€',
                    }
                  ]
                },
                {
                  name: 'Dépose de vernis semi-permanent & soin des ongles',
                  alternatives: [
                    {
                      description: '',
                      duration: '30 min',
                      price: '20€',
                    }
                  ]
                },
              ]
            } ,
            {
              title: 'Prothésie ongulaire',
              items: [
                {
                  name: 'Pose de gel',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '49€',
                    }
                  ]
                },
                {
                  name: 'Extension',
                  alternatives: [
                    {
                      description: '(Sur chablons)',
                      duration: '',
                      price: '60€',
                    }
                  ]
                },
                {
                  name: 'Pose de gel & couleur / French',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '59€',
                    }
                  ]
                },
                {
                  name: 'Pose de gel + extension + couleur / French',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '69€',
                    }
                  ]
                },

                {
                  name: 'Dépose de gel',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '35€',
                    }
                  ]
                },

                {
                  name: 'Réparation à l\'unité',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '5€',
                    }
                  ]
                },
                {
                  name: 'Déco à l\'unité',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '0,50€',
                    }
                  ]
                },
              ]
            }
              
      

          ]
        },
      ],

    }
  }

  mounted()
  {
    this.$store.commit('setPageLoadState', true)
  }





}

</script>
